import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase, faCogs, faChartPie } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

// 1. Foundations, Storage, and Distributed Computing
const labelsFirst = [
    "Data Modeling",
    "Apache Spark",
    "Hadoop & Hive",
    "PostgreSQL",
    "SQL Server",
    "AWS (S3, Athena)"
];

// 2. Data Flows, Transformation, and Industrialization
const labelsSecond = [
    "Apache Airflow",
    "dbt",
    "Python & SQL",
    "Sqoop",
    "Docker",
    "Git",
    "Linux"
];

// 3. Analytics and Intelligence
const labelsThird = [
    "Power BI",
    "Amazon QuickSight",
    "Looker Studio",
    "Generative AI / LLMs",
    "RAG Architecture",
    "CrewAI / LangChain",
    "NLP"
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                
                <div className="skill">
                    <FontAwesomeIcon icon={faDatabase} size="3x"/>
                    <h3>Data Architecture & Distributed Systems</h3>
                    <p>Before writing any code, I focus on architecture and data modeling. From traditional relational Data Warehouses to Modern Data Lakehouses, I design scalable foundations capable of storing and processing massive data volumes efficiently.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faCogs} size="3x"/>
                    <h3>Robust Pipelines & Orchestration</h3>
                    <p>The true value of a data architecture relies on the reliability of its data flows. I apply software engineering best practices (containerization, git) to Data Engineering, building and orchestrating resilient, fully tested, and automated ETL/ELT pipelines.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faChartPie} size="3x"/>
                    <h3>Data Valorization & Applied AI</h3>
                    <p>Raw data is only valuable when it drives action. I transform complex data models into intuitive dashboards to solve real-world business challenges and empower decision-making.
                    I also engineer custom Generative AI solutions. By leveraging LLMs, RAG architectures, and multi-agent systems, to turn unstructured data into intelligent conversational assets.
                    </p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

            </div>
        </div>
    </div>
    );
}

export default Expertise;